module.exports = __webpack_public_path__ + "static/media/Logo.eef5868a.svg";